import { isBrowser } from '../../../helpers';

const checkIfRangeUpdated = (value, min, max) => {
  const { minValue, maxValue } = value;
  return isBrowser() && (minValue !== min || maxValue !== max);
};

export default checkIfRangeUpdated;
